import { useMutation } from "@tanstack/react-query";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import { useNotification } from "~hooks/useNotification.ts";
import { useSportConfiguration } from "~hooks/useSportConfiguration";
import type { DefaultOperationSuccessResponse } from "~types/response.ts";
import { useApi } from "../../../../hooks/apiHooks/useApi";

export const useExportSeasonOfficials = () => {
  const { sport = "", organizationId = "", seasonId = "" } = useParams();
  const { formatMessage } = useIntl();
  const request = useApi();
  const notification = useNotification();
  const { seasonOfficialRoles } = useSportConfiguration();

  return useMutation<DefaultOperationSuccessResponse, Error, string[]>({
    mutationFn: (fieldNames) =>
      request(`${sport}/o/${organizationId}/seasons/${seasonId}/personRoles/export`, {
        method: "POST",
        body: {
          fieldNames,
          exportName: "season officials",
          personRoles: seasonOfficialRoles,
        },
      }),
    onSuccess: (response) => {
      if (response?.data?.[0]?.success) {
        notification.success({
          message: formatMessage({ id: "seasonOfficials.export.started" }),
          placement: "bottomRight",
        });
      }
    },
  });
};
